export default "__VITE_ASSET__kMGcyXXQ__"